import { JSX } from "react";

import { Box } from "@mui/material";

const styles = {
  spacer: { minWidth: 16, display: { xs: "block", sm: "none" } },
};

function MobileScrollSpacer(): JSX.Element {
  return <Box sx={styles.spacer} />;
}

export default MobileScrollSpacer;
